import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgAlarm = function SvgAlarm(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M14.236 19.292H9.764a.25.25 0 00-.248.222 2.5 2.5 0 104.968 0 .248.248 0 00-.248-.222zM21.446 17.691c-1.145-1.886-1.742-3.967-1.746-6.08v-.636c.056-2.508-1.392-4.876-3.866-6.32a7.197 7.197 0 00-2.334-.761v-.942c0-.687-.672-1.244-1.5-1.244-.829 0-1.5.557-1.5 1.244v.953a7.472 7.472 0 00-2.851 1.059C5.487 6.44 4.255 8.653 4.3 10.975v.637c-.004 2.111-.602 4.193-1.746 6.08a.354.354 0 00.021.403.53.53 0 00.425.197h18a.53.53 0 00.425-.198.354.354 0 00.021-.403z"
  }));
};

export default SvgAlarm;